import { useState, useRef } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import {
  Popover,
  __experimentalHStack as HStack,
  __experimentalVStack as VStack,
  __experimentalText as Text,
  __experimentalToolsPanelItem as ToolsPanelItem,
  __experimentalToolsPanel as ToolsPanel,
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
  Button,
} from '@wordpress/components';
import {VayuBlocksBackground} from  '@vayu-blocks';

const backgroundAnimationMap = {
  'effect-beans': { className: 'effect-beans', label: __('Beans', 'vayu-blocks') },
  'effect-zoom': { className: 'effect-zoom', label: __('Zoom', 'vayu-blocks') },
};

const backgroundAnimationOptions = [
  { label: __('None', 'vayu-blocks'), value: 'none' },
  ...Object.entries(backgroundAnimationMap).map(([value, data]) => ({
    label: data.label,
    value,
  })),
];

const getAnimationClass = (value) => {
  switch (value) {
      case 'effect-beans':
      return 'animation-preview effect-beans';
      case 'effect-zoom':
      return 'animation-preview effect-zoom';
      
    default:
      return '';
  }
};

const ButtonEffects = ({ attributes, setAttributes }) => {
  const { animationData = { background: { value: 'none', type: 'onhvr' } } } = attributes;
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);
  const buttonRef = useRef(null);

  // useEffect(() => {
  //   console.log('ButtonEffects: Current animationData:', animationData);
  // }, [animationData]);
  
  const handleAnimationClick = (animation) => {
    const currentHoverType = animationData?.background?.type || 'onhvr';
    const updatedAnimationData = {
      ...animationData,
      background: {
        ...animationData.background,
        value: animation,
        type: currentHoverType,
      },
    };
  
    const updatedAttributes = { animationData: updatedAnimationData };

    

    

  
    setAttributes(updatedAttributes);
    setIsPopoverVisible(false);
  };
  

  const handleTriggerChange = (value) => {
    const updatedAnimationData = {
      ...animationData,
      background: {
        ...animationData.background,
        type: value,
      },
    };
    setAttributes({ animationData: updatedAnimationData });
  };

  const hasValue = () => animationData?.background?.value && animationData.background.value !== 'none';
  
  const onDeselect = () => {
    setAttributes({
      animationData: {
        ...animationData,
        background: { value: 'none', type: 'onhvr' },
      },
    });
  };
  

  const selectedBackgroundEffect = Object.entries(backgroundAnimationMap).find(
    ([_, data]) => data.className === animationData?.background?.value
  )?.[1].label || __('None', 'vayu-blocks');

  const handleEffectColorChange = (value) => {
    const updatedAnimationData = {
      ...animationData,
      background: {
        ...animationData.background,
        bg: value,
      },
    };
    setAttributes({ animationData: updatedAnimationData }); // Use setAttributes instead of onChange
  };
  
  return (
    <ToolsPanel label={__('Button Effects', 'vayu-blocks')}
    className="vayu-buttoneffects-toolspanel" >
      <ToolsPanelItem
        className="vayu_blocks_animation_toolspanel_item"
        hasValue={hasValue}
        onDeselect={onDeselect}
        label={__('Effect', 'vayu-blocks')}
        isShownByDefault={true}
      >
        <Button
          ref={buttonRef}
          onClick={() => setIsPopoverVisible(!isPopoverVisible)}
          className={`block-editor-panel-animation-settings__dropdown vayu-effect-btn ${
            isPopoverVisible ? 'is-open' : ''
          }`}
        >
          <HStack alignment="left">
            {!animationData?.background?.value || animationData.background.value === 'none' ? (
              <div className="vayu-blocks-panel-ihover vayu-blocks-none-button toolaspanel-size-none-button vayu_blocks_none" />
            ) : (
              <div
                className={`vayu_blocks_hstack_animation_panel_image vayu_blocks_hstack_animation_panel_image_color ${getAnimationClass(
                  animationData.background.value
                )}`}
                style={{ width: '20px', height: '20px', border: '1px solid #ddd', borderRadius: '4px' }}
              />
            )}
            <Text style={{ marginLeft: '5px' }}>{selectedBackgroundEffect}</Text>
          </HStack>
        </Button>
        {isPopoverVisible && buttonRef.current && (
          <Popover
            placement="left-start"
            className="vayu_blocks_toolspanel_items_popover vayu-btneffect-popover"
            anchor={buttonRef.current}
            onClose={() => setIsPopoverVisible(false)}
            offset={35}
            resize
          >
            <VStack style={{ padding: '10px', width: '280px' }}>
              <Text>
                <h4>{__('Button Effects', 'vayu-blocks')}</h4>
                <p>{__('Select an effect for your button element.', 'vayu-blocks')}</p>
              </Text>
              <HStack spacing="3" wrap={true} justify="flex-start">
                <Text className="vayu_blocks_selected_saniamtion">
                  {backgroundAnimationOptions.map(({ label, value }) => (
                    <Text
                      key={value}
                      style={{ padding: '8px' }}
                      className={`vayu-blocks-ihover-main-panel vayu_blocks_animation_panel_button_svg animation-card ${
                        animationData?.background?.value === value ? 'selected' : ''
                      }`}
                      onClick={() => handleAnimationClick(value)}
                    >
                      {value === 'none' ? (
                        <div
                          style={{ margin: '0px 3px' }}
                          className="vayu-blocks-panel-ihover vayu-blocks-none-button"
                        />
                      ) : (
                        <Text
                          className={`vayu-buttons-panel-ihover-effects vayu-effects-animation-bg vayu_buttons_animation_bg ${getAnimationClass(
                            value
                          )}`}
                        
                        >
                          {label}
                        </Text>
                      )}
                    </Text>
                  ))}
                </Text>
              </HStack>
              
              <br/>

              {/* <Text>
                <VayuBlocksBackground
                  onChange={(key,value)=>handleEffectColorChange(value)}
                  colorPanel = {[
                      {
                          active: ['color'],
                          label: 'Wrapper / Effect Color',
                          key:'animationData',
                          value: animationData?.background?.bg,
                      },
                  ]}
                />
              </Text> */}
              
            </VStack>
          </Popover>
        )}
      </ToolsPanelItem>
    </ToolsPanel>
  );
};

export default ButtonEffects;